import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Stats } from "@/components/Stats";
import { Services } from "@/components/Services";
import { SipCalculator } from "@/components/SipCalculator";
import { About } from "@/components/About";
import { Testimonials } from "@/components/Testimonials";
import { FAQ } from "@/components/FAQ";
import { Offices } from "@/components/Offices";
import { LeadSection } from "@/components/LeadSection";
import { Footer } from "@/components/Footer";
import { FloatingWhatsApp } from "@/components/FloatingWhatsApp";
import Admin from "@/pages/Admin";

const Landing = () => (
  <div className="min-h-screen bg-bone text-foreground">
    <Navbar />
    <main>
      <Hero />
      <Stats />
      <Services />
      <SipCalculator />
      <About />
      <Testimonials />
      <FAQ />
      <Offices />
      <LeadSection />
    </main>
    <Footer />
    <FloatingWhatsApp />
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
